import LanguageSwitcher from '@/components/common/LanguageSwitcher';

const MusicRegistrationHeader = () => (
  <header className="relative z-10 border-b border-gray-200 bg-white">
    <div className="mx-auto flex min-h-20 max-w-6xl items-center justify-between gap-4 px-5 sm:px-8">
      <span className="select-none font-brand text-2xl font-bold text-[#2F5249]">Tutor Founder</span>
      <LanguageSwitcher
        className="w-[4.75rem] sm:w-[6.5rem]"
        showLabel={false}
        compact
        showMalay
        menuWidthMode="content"
        menuMinWidth={152}
        dropdownButtonClassName="min-h-11 rounded-lg border-gray-300 bg-white px-3 text-sm font-semibold text-gray-700 hover:border-primary focus:ring-2 focus:ring-primary/20"
      />
    </div>
  </header>
);

export default MusicRegistrationHeader;
